import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import store from '../store'

export default class Project extends Highway.Transition {
  in({ from, done }) {
    window.scrollTo(0, 0)
    done()
    from.remove()

    setTimeout(() => this.startSmoothScroll(), 500)

    store.menu.unlock()
    store.isMobile && store.menu.reset()
  }

  out({ from, done }) {
    this.getElems()
    this.stopSmoothScroll()

    setTimeout(() => {
      this.showLoader(from).then(done)
    }, 0);
  }

  showLoader() {
    return new Promise((resolve) => {
      const y = this.image.getBoundingClientRect().top - this.el.getBoundingClientRect().top
      const tl = gsap.timeline({
        delay: 1.3,
        onComplete: () => {
          resolve()
        }
      })

      store.menu.lock()
      store.smoothScroll.scrollTo(this.el, {
        callback: () => {
          !store.isMobile && store.menu.reset()
        }
      })

      gsap.to(this.title, {
        opacity: 0,
        ease: 'expo.out',
        duration: 0.5
      })

      tl
      .addLabel('start', 0)
      .to(this.image, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        ease: 'expo.out',
        duration: 1.2
      }, 'start')
      .to(this.image, {
        y: -y + 120,
        ease: 'expo.out',
        duration: 1.2
      }, 'start')
      .to(this.image.children[0], {
        scale: 1,
        ease: 'expo.out',
        duration: 1.2
      }, 'start')
      .to(this.el, {
        backgroundColor: '#e8e8e8',
        ease: 'expo.out',
        duration: 0.5
      })
    })
  }

  getElems() {
    this.el = document.querySelector('.c-next-project')
    this.image = this.el.querySelector('.c-next-project__image')
    this.title = this.el.querySelector('.c-next-project__title')
  }

  startSmoothScroll() {
    if (!store.smoothScroll) return

    if (store.isMobile) {
      window.scrollTo(0, 0)
      store.smoothScroll.update()
      store.smoothScroll.start()
    } else {
      store.smoothScroll.setScroll(0, 0)
      store.smoothScroll.update()
      store.smoothScroll.scroll.scrollbarThumb.style.height = `${window.innerHeight * window.innerHeight / (store.smoothScroll.scroll.instance.limit + window.innerHeight)}px`
      store.smoothScroll.scroll.scrollBarLimit = window.innerHeight - store.smoothScroll.scroll.scrollbarThumb.getBoundingClientRect().height
      store.smoothScroll.scroll.startScrolling()
      store.smoothScroll.start()
    }
  }

  stopSmoothScroll() {
    if (!store.smoothScroll) return

    if (store.isMobile) store.smoothScroll.stop()
    else {
      store.smoothScroll.scroll.stopScrolling()
      store.smoothScroll.stop()
    }
  }
}
